import { useLingui } from '@lingui/react/macro';

import { MobileEntityFilter } from '@/components/SharedFilters/EntityFilter/MobileEntityFilter';
import IconStoreRepair from '@/icons/StoreRepair.svg';

import { useFilters } from '../FiltersState';

export const FiltersStore = () => {
  const { t } = useLingui();

  const {
    stores: { stores, setStores },
  } = useFilters();

  return (
    <MobileEntityFilter
      filterId="store"
      selectedEntities={stores}
      setSelectedEntities={setStores}
      traits={['store']}
      label={t({ id: 'requests.filters.store.label', message: 'Store' })}
      searchPlaceholder={t({
        id: 'requests.filters.store.search.label',
        message: 'Search stores',
      })}
      icon={<IconStoreRepair />}
    />
  );
};
